<template>
    <div>
        <el-dialog class="dialog" :title="VDialogTitle" :close-on-click-modal="false" :visible="VDialogVisible" @close="closeVDialog"
            width="65%">
            <el-table :data="variousData" height="500" stripe border v-loading="Vloading" :row-style="{ height: '58px' }"
                :cell-style="{ padding: '5px 0' }" size="small" fit element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
                style="width: 100%">
                <el-table-column prop="poolCode" label="销售资金池编码" align="center">
                </el-table-column>
                <el-table-column prop="saleUserName" label="销售人员" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.saleUserName || '--' }}
                    </template>
                </el-table-column>
                <el-table-column prop="variousCostName" label="费用类型" align="center">
                </el-table-column>
                <el-table-column prop="variousCostFee" label="费用金额(元)" sortable :sort-method="(a, b) => {
                    return a.variousCostFee - b.variousCostFee;
                }" align="center">
                </el-table-column>
                <el-table-column prop="rq" label="费用日期" align="center">
                </el-table-column>
                <el-table-column prop="remarks" label="备注" align="center">
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 20px">
                <div class="moneyTotal">
                    <span class="label">金额合计:</span> {{ variousData.reduce((prev, cur) =>  prev + cur.variousCostFee, 0).toFixed(2) }}元
                </div>
                <div></div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="VDialogVisible = false">关 闭</el-button>
            </span>
        </el-dialog>
        
        <el-dialog class="dialog" title="项目资金结转列表" :close-on-click-modal="false" :visible="TDialogVisible" @close="closeTDialog"
            width="65%">
            <el-table :data="transferData" height="500" stripe border v-loading="Tloading" :row-style="{ height: '58px' }"
                :cell-style="{ padding: '5px 0' }" size="small" fit element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
                style="width: 100%">
                <el-table-column prop="poolCode" label="销售资金池编码" align="center">
                </el-table-column>
                <el-table-column prop="projectId" label="项目编码" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.poolName.split('_')[0] + '_' + scope.row.projectId }}
                    </template>
                </el-table-column>
                <el-table-column prop="projectName" label="项目名称" align="center">
                </el-table-column>
                <el-table-column prop="transferFee" label="费用金额(元)" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="openBuyDialog(scope.row.projectId)">{{ scope.row.transferFee }}</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="transferTime" label="结转时间" align="center" min-width="130" :formatter="dateTimeTwoLine" class-name="cell-two-line">
                </el-table-column>
                <el-table-column prop="remarks" label="备注" align="center">
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div style="display: flex; justify-content: space-between;  align-items: center; margin-top: 20px">
                <div class="moneyTotal">
                    <span class="label">费用合计:</span>{{ transferData.reduce((prev, cur) =>  prev + cur.transferFee, 0).toFixed(2) }}元
                </div>
                <div></div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="TDialogVisible = false">关 闭</el-button>
            </span>
        </el-dialog>

        <el-dialog class="dialog" title="项目资金结转费用明细" :close-on-click-modal="false" :visible="buyDetailDialog"
            @close="buyDetailDialog = false" width="65%">
            <div class="transferItem">
                <h3 style="margin-bottom: 20px; font-size: 16px">项目费用列表:</h3>

                <el-table :data="costData" height="220" stripe border v-loading="Cloading" :row-style="{ height: '58px' }"
                :cell-style="{ padding: '5px 0' }" size="small" fit element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
                style="width: 100%">
                    <el-table-column prop="bm" label="项目编码" align="center">
                    </el-table-column>
                    <el-table-column prop="projectName" label="项目名称" align="center">
                    </el-table-column>
                    <el-table-column prop="costName" label="费用名称" align="center">
                    </el-table-column>
                    <el-table-column prop="cost" label="费用金额(元)" align="center">
                    </el-table-column>
                    <el-table-column prop="bz" label="备注" align="center">
                    </el-table-column>
                    <el-table-column prop="rq" label="费用日期" align="center">
                    </el-table-column>
                </el-table>

                <!-- 分页 -->
                <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 20px">
                    <div class="moneyTotal">
                        <span class="label">费用合计:</span>  {{ costData.reduce((prev, cur) =>  prev + cur.cost, 0).toFixed(2) }}元
                    </div>
                    <div>
                    </div>
                </div>
                <!-- 分页 -->
            </div>
            <div class="transferItem">
                <h3 style="margin-bottom:20px; font-size: 16px">项目采购列表:</h3>

                <el-table :data="buyData" height="220" stripe border v-loading="Bloading" :row-style="{ height: '58px' }"
                    :cell-style="{ padding: '5px 0' }" size="small" fit element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
                    style="width: 100%">
                    <el-table-column prop="bm" label="项目编码" align="center">
                    </el-table-column>
                    <el-table-column prop="projectName" label="项目名称" align="center">
                    </el-table-column>
                    <el-table-column prop="buyMoney" label="采购支付金额(元)" align="center">
                    </el-table-column>
                    <el-table-column prop="bz" label="备注" align="center">
                    </el-table-column>
                    <el-table-column prop="rq" label="采购支付日期" align="center">
                    </el-table-column>
                    
                </el-table>

                <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 20px">
                    <div class="moneyTotal">
                        <span class="label">金额合计:</span> {{ buyData.reduce((prev, cur) =>  prev + cur.buyMoney, 0).toFixed(2) }}元
                    </div>
                </div>

            </div>
            
            <span slot="footer" class="dialog-footer">
                <el-button @click="buyDetailDialog = false">关 闭</el-button>
            </span>

        </el-dialog>

        <!-- <div class="topSearch">
            <div class="title"> {{ queryForm.year.getFullYear() }}年资金池 </div>
            <el-form :inline="true">
                <el-form-item label="选择年份" style="margin-right: 20px">
                    <el-date-picker
                        :clearable="false"
                        :picker-options="{
                            disabledDate: disabledFutureYear
                        }"
                        v-model="queryForm.year"
                        type="year"
                        placeholder="选择年">
                    </el-date-picker>
                </el-form-item>
            </el-form>
        </div> -->

        <el-table :data="tableData" stripe border :row-style="{ height: '58px' }" height="calc(100vh - 148px)"
            :cell-style="{ padding: '5px 0' }" size="small" fit v-loading="loading" element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
            style="width: 100%">
            <el-table-column prop="poolCode" label="资金池编码" align="center">
            </el-table-column>
            <el-table-column prop="userName" label="销售人员" align="center">
                <template slot-scope="scope">
                    {{ scope.row.userName || '--' }}
                </template>
            </el-table-column>
            <el-table-column prop="totalAmount" sortable :sort-method="(a, b) => {
                    return a.totalAmount - b.totalAmount;
                }" label="资金池总金额(元)" align="center" width="165">
            </el-table-column>
            <el-table-column prop="transferFee" sortable :sort-method="(a, b) => {
                    return a.transferFee - b.transferFee;
                }
                " label="项目结转金额(元)" align="center" width="165">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.transferFee > 0" type="text"
                        @click="openTransferFeeDialog(scope.row.poolCode)">{{ scope.row.transferFee }}</el-button>
                    <span v-else>--</span>
                </template>
            </el-table-column>
            <el-table-column label="费用(元)" align="center">
                 <el-table-column prop="trafficFee" sortable :sort-method="(a, b) => {
                    return a.trafficFee - b.trafficFee;
                }
                    " label="运输费用(元)" align="center">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.trafficFee > 0" type="text"
                            @click="openVariousCostDialog(scope.row.poolCode,'vc001')">{{
                                scope.row.trafficFee }}</el-button>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column prop="printerFee" sortable :sort-method="(a, b) => {
                        return a.printerFee - b.printerFee;
                    }
                    " label="办公费用(元)" align="center">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.printerFee > 0" type="text"
                            @click="openVariousCostDialog(scope.row.poolCode,'vc002')">{{
                                scope.row.printerFee }}</el-button>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column prop="variousCostFee" sortable :sort-method="(a, b) => {
                        return a.variousCostFee - b.variousCostFee;
                    }
                    " label="小计" align="center">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.variousCostFee > 0" type="text"
                            @click="openVariousCostDialog(scope.row.poolCode)">{{ scope.row.variousCostFee }}</el-button>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
            </el-table-column> 
        </el-table>
    </div>
</template>
<script>
import { getFundPoolList, getVariousList, getTransferProjectList, getProjectBuyList, getProjectCostList } from '@/api/proj';
export default {
    data() {
        return {
            VDialogTitle: '', // 费用标题
            buyDetailDialog: false,
            costDetailDialog: false,
            loading: false,
            costData: [],
            tableData: [],
            moneyTransferList: [],
            VDialogVisible: false,
            TDialogVisible: false,
            variousData: [],
            transferData: [],
            buyData: [],
            Tloading: false,
            Vloading: false,
            Bloading: false,
            Cloading: false,
            queryForm: {
                year: new Date(),
                page: 1,
                limit: 9999,
            },
            transferForm: {
                page: 1,
                limit: 9999,
            },
            buyForm: {
                page: 1,
                limit: 9999,
            },
            costForm: {
                page: 1,
                limit: 9999,
            },
            Vtotal: 0,
            Ttotal: 0,
            Btotal: 0,
            Ctotal: 0,
        }
    },
    created() {
        this.getFundPoolList();
    },
    computed: {

    },
    methods: {
        // 禁用未来年份的核心方法
        disabledFutureYear(date) {
            // 获取当前年份
            const currentYear = new Date().getFullYear();
            // 获取选中的年份
            const selectYear = date.getFullYear();

            // 如果选中的年份大于当前年份，则禁用该年份
            return selectYear > currentYear;
        },
        // 打开费用详情弹窗
        openCostDialog(projectId) {
            this.costForm.projectId = projectId;
            this.getProjectCostList();
            this.costDetailDialog = true;
        },
        getProjectCostList() {
            this.Cloading = true;
            getProjectCostList(this.costForm).then(res => {
                if (res.code === 200) {
                    this.Ctotal = res.count;
                    this.costData = res.data;
                    this.Cloading = false;
                }
            })
        },
        // 打开采购详情弹窗
        openBuyDialog(projectId) {
            this.costForm.projectId = projectId;
            this.buyForm.projectId = projectId;
            this.getProjectBuyList();
            this.getProjectCostList();
            this.buyDetailDialog = true;
        },
        getProjectBuyList() {
            this.Bloading = true;
            getProjectBuyList(this.buyForm).then(res => {
                if (res.code === 200) {
                    this.Btotal = res.count;
                    this.buyData = res.data;
                    this.Bloading = false;
                }
            })
        },
        openTransferFeeDialog(poolCode) {
            this.transferForm.poolCode = poolCode;
            this.getTransferList();
            this.TDialogVisible = true;
        },
        getTransferList() {
            this.Tloading = true;
            let form = {
                page: this.transferForm.page,
                limit: this.transferForm.limit,
            }
            if (this.transferForm.poolCode) form.poolCode = this.transferForm.poolCode;
            getTransferProjectList(form).then(res => {
                if (res.code === 200) {
                    this.transferData = res.data;
                    this.Tloading = false;
                    this.Ttotal = res.count;
                }
            })
        },
        closeTDialog() {
            this.transferForm = {
                page: 1,
                limit: 9999,
            },
                this.TDialogVisible = false
        },
        closeVDialog() {
            this.queryForm = {
                page: 1,
                limit: 9999,
            },
                this.VDialogVisible = false
        },
        closeBDialog() {
            this.buyForm = {
                page: 1,
                limit: 9999,
            },
                this.buyDetailDialog = false
        },
        closeCDialog() {
            this.costForm = {
                page: 1,
                limit: 9999,
            },
                this.costDetailDialog = false
        },
        currentChange(e) {
            this.queryForm.page = e;
            this.getVariousList();
        },
        sizeChange(e) {
            this.queryForm.limit = e;
            this.getVariousList();
        },
        tcurrentChange(e) {
            this.transferForm.page = e;
            this.getTransferList();
        },
        tsizeChange(e) {
            this.transferForm.limit = e;
            this.getTransferList();
        },
        bcurrentChange(e) {
            this.buyForm.page = e;
            this.getProjectBuyList();
        },
        bsizeChange(e) {
            this.buyForm.limit = e;
            this.getProjectBuyList();
        },
        ccurrentChange(e) {
            this.costForm.page = e;
            this.getProjectCostList();
        },
        csizeChange(e) {
            this.costForm.limit = e;
            this.getProjectCostList();
        },
        // 搜索中
        onSearch() {
            this.queryForm.page = 1;
            this.getVariousList();
        },
        // 打开所有科目费用
        openVariousCostDialog(poolCode,variousCostCode) {
            if(variousCostCode === 'vc001'){
                this.VDialogTitle = '运输费用'
            }else if(variousCostCode === 'vc002'){
                this.VDialogTitle = '办公费用'
            }else{
                this.VDialogTitle = '科目费用'
            }
            this.queryForm.poolCode = poolCode;
            variousCostCode ? this.queryForm.variousCostCode = variousCostCode : 0
            this.getVariousList();
            this.VDialogVisible = true;
        },
        getFundPoolList() {
            getFundPoolList({
                page: 1,
                limit: 1000
            }).then(res => {
                if (res.code === 200) {
                    this.tableData = res.data;
                }
            })
        },
        getVariousList() {
            this.Vloading = true;
            let form = {
                page: this.queryForm.page,
                limit: this.queryForm.limit,
            }
            if (this.queryForm.poolCode) form.poolCode = this.queryForm.poolCode;
            if (this.queryForm.variousCostCode) form.variousCostCode = this.queryForm.variousCostCode;
            getVariousList(form).then(res => {
                if (res.code === 200) {
                    this.Vtotal = res.count;
                    this.variousData = res.data;
                    this.Vloading = false;
                }
            })
        },
    },
}
</script>
<style lang="scss" scoped>
.table1{
    height:550px;
    overflow-y: auto;
}
.table2{
    height:220px;
    overflow-y: auto;
}
.moneyTotal{
    display: flex;
    
    .label{
        margin-right: 8px;
    }
}
.topSearch {
    display: flex;
    justify-content: space-between;

    .title{
        font-size: 18px;
        font-weight: bold;
    }
}
.transferItem{
    margin-bottom: 40px;
}
</style>
